import styles from "./ContactModal.module.css";

export default function ContactModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Schließen"
        >
          ×
        </button>

        <div className={styles.modalContent}>
          <h2 className={styles.title}>Kontakt</h2>

          <div className={styles.contactInfo}>
            <p className={styles.intro}>
              Wir freuen uns darauf, Sie und Ihre Projekte kennenzulernen.
              <br />
              Ihr Stahlfaktor Team
            </p>

            <a href="mailto:info@stahlfaktor.de" className={styles.email}>
              info@stahlfaktor.de
            </a>

            <p className={styles.phone}>02333 / 616101</p>
          </div>
        </div>
      </div>
    </div>
  );
}
